const CORE_STACK = [
    "PHP / PYTHON / GO",
    "REACT / MYSQL / MONGODB"
];

const INFRASTRUCTURE = ["Docker", "Linux", "Bash", "Git"];

const HUMAN_LOGIC_SKILLS = [
    "Task Management",
    "Problem Solving",
    "Team Collaboration",
    "Communication"
];

function DecorationTriangle() {
    return (
        <div className="absolute bottom-0 right-0 lg:-mr-4 lg:-mb-4 pointer-events-none">
            <svg width="160" height="160" viewBox="0 0 100 100" fill="none">
                <path d="M0 100 L100 100 L100 0 Z" stroke="#99a1af" strokeWidth="1" />
                <path d="M20 100 L100 20" stroke="#99a1af" strokeWidth="1" />
                <path d="M40 100 L100 40" stroke="#99a1af" strokeWidth="1" />
                <path d="M60 100 L100 60" stroke="#99a1af" strokeWidth="1" />
                <path d="M80 100 L100 80" stroke="#99a1af" strokeWidth="1" />
            </svg>
        </div>
    );
}

function StackSection() {
    return (
        <div className="flex flex-col">
            <div className="relative mb-15">
                <h2 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl font-black leading-[0.85] mb-2 lg:mb-4">
                    Core Stack
                </h2>
                <div>
                    {CORE_STACK.map((line, index) => (
                        <p key={index} className="font-display uppercase text-4xl md:text-5xl lg:text-6xl font-black leading-[0.85]">
                            {line}
                        </p>
                    ))}
                </div>
            </div>

            <div className="mt-auto">
                <div className="w-12 h-[2px] bg-black mb-6"></div>
                <h3 className="font-display uppercase text-3xl font-black mb-2 tracking-tight">
                    Infrastructure & Flow
                </h3>
                <p className="text-gray-600">
                    {INFRASTRUCTURE.join(" • ")}
                </p>
            </div>
        </div>
    );
}

function HumanLogicSection() {
    return (
        <div className="flex items-end justify-end relative">
            <div className="mb-12 relative z-10 mr-10">
                <h2 className="font-display uppercase text-6xl md:text-8xl lg:text-9xl font-black leading-[0.85] mb-2 lg:mb-4">
                    Human Logic
                </h2>
                <div className="space-y-1">
                    {HUMAN_LOGIC_SKILLS.map((skill, index) => {
                        const sizeClass = index === 0 ? "text-4xl md:text-6xl lg:text-7xl" : "text-3xl md:text-5xl lg:text-6xl";
                        return (
                            <p key={index} className={`font-display uppercase ${sizeClass} font-black leading-[0.85]`}>
                                {skill}
                            </p>
                        );
                    })}
                </div>
            </div>
            <DecorationTriangle />
        </div>
    );
}

export function Skills() {
    return (
        <section className="py-16 w-full" id="skills">
            <div className="max-w-7xl mx-auto relative flex flex-col gap-12 lg:gap-24 lg:gap-8">
                <StackSection />
                <HumanLogicSection />
            </div>
        </section>
    );
}

export default Skills;
